import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { LandingPage } from './features/landing/landing-page';
import './styles/globals.css';

// The public page does not need the CRM, authentication, or its data providers.
// Its links use full navigation so the authenticated entry loads only on entry.
const AppEntry = lazy(() => import('./app/app-entry'));

const container = document.getElementById('root');

if (!container) {
  throw new Error('Elemento #root não encontrado no index.html');
}

createRoot(container).render(
  <StrictMode>
    <Suspense
      fallback={
        <div role="status" className="p-8">
          Carregando seu escritório…
        </div>
      }
    >
      {window.location.pathname === '/' ? <LandingPage /> : <AppEntry />}
    </Suspense>
  </StrictMode>,
);
